module.exports = __webpack_public_path__ + "img/19d059966ddb1db1b0c032be562ee081.jpg";